























































import {Vue, Component} from 'vue-property-decorator';
import {StetniDogadjaj} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component
export default class UnosStetnogDogadjaja extends mixins(ComponentBaseMixin) {
    steta = StetniDogadjaj.fromJS({datum: new Date()});
    isBusy = false;
    sacuvajStetu() {}
    novaSteta() {
        this.steta = StetniDogadjaj.fromJS({datum: new Date()});
    }
    async sacuvaj() {
        if (this.isBusy) return;
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            try {
                this.isBusy = true;
                this.steta = await this.saveData(() => dataProxy.sacuvajStetniDogadjaj(this.steta))();
            } finally {
                this.isBusy = false;
            }
        }
    }
}
